import { inject } from '@angular/core';

import { FeatureFlag, phishingPilotFeatureFlags } from './constants';
import { FeatureFlagService } from './feature-flag.service';

export const hasFlag = (flag: string) =>
  inject(FeatureFlagService).getBooleanFlag(flag, false);

export function isFeaturesEnabledByGWLPhishingPilot(
  featureFlagService: Pick<FeatureFlagService, 'getBooleanFlag'>,
  flag: string
): boolean {
  if (!phishingPilotFeatureFlags.has(flag)) {
    return false;
  }
  return (
    featureFlagService.getBooleanFlag(flag) ||
    featureFlagService.getBooleanFlag(FeatureFlag.ROLLOUT_GWL_PHISHING_PILOT)
  );
}
